import { FunctionComponent, useCallback, useState } from 'react';
import { useIam } from '../../../services/IAm/hooks';
import { PublicReview } from '@shared/types';
import { CademyAPI } from '../../../services/CademyAPI';
import TrashRegularIcon from '../../Icons/TrashRegularIcon';

import styles from './styles.module.scss';
import Button from '../../Button';

export const DeleteReviewButton: FunctionComponent<{
    reviewId: PublicReview['id'];
    reviewerId: PublicReview['reviewer']['id'];
}> = ({ reviewId, reviewerId }) => {
    const { iam } = useIam();
    const [showConfirm, setShowConfirm] = useState(false);

    const handleCancel = useCallback(() => {
        setShowConfirm(false);
    }, []);

    const handleDelete = useCallback(async () => {
        await CademyAPI('ArchiveReview')({ urlParams: { id: reviewId } });
        window.location.reload();
    }, [reviewId]);

    const handleInitialClick = useCallback(() => {
        setShowConfirm(true);
    }, []);

    if (!iam || !iam.authenticated) {
        return null;
    }

    if (iam.studentId !== reviewerId) {
        return null;
    }

    return (
        <div className={styles.deleteButtonContainer}>
            {showConfirm ? (
                <div className={styles.confirmContainer}>
                    <Button onClick={handleDelete} preset="danger">
                        Delete
                    </Button>
                    <Button onClick={handleCancel}>Cancel</Button>
                </div>
            ) : (
                <TrashRegularIcon onClick={handleInitialClick} className={styles.deleteButton} />
            )}
        </div>
    );
};

export default DeleteReviewButton;
